"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    RequestFromType: ()=>Survey_RequestFromType,
    default: ()=>Survey_Survey
});
const jsx_runtime_namespaceObject = require("react/jsx-runtime");
require("react");
const external_pcln_design_system_namespaceObject = require("pcln-design-system");
const external_pcln_icons_namespaceObject = require("pcln-icons");
const misc_js_namespaceObject = require("../../constants/misc.js");
var Survey_RequestFromType = /*#__PURE__*/ function(RequestFromType) {
    RequestFromType["HOMEPAGE"] = "homePage";
    RequestFromType["POSTBOOKING"] = "travel-itinerary";
    RequestFromType["PENNYPORTAL"] = "pennyPortalPage";
    return RequestFromType;
}({});
const Survey = ({ onClose, requestFrom })=>{
    function handleOpen() {
        if ("homePage" === requestFrom) window.open(`${misc_js_namespaceObject.QUALTRICS_URL}?Page=HP`, '_blank');
        else if ("travel-itinerary" === requestFrom) window.open(`${misc_js_namespaceObject.QUALTRICS_URL}?Page=PB`, '_blank');
    }
    function handleClose() {
        onClose();
    }
    return /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
        p: 5,
        textAlign: "center",
        children: [
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                fontWeight: "bold",
                fontSize: 3,
                mb: 3,
                children: "Help us Improve Penny!"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Text, {
                fontSize: 1,
                children: [
                    "Give us 5 minutes and we'll give you",
                    ' ',
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text.span, {
                        fontWeight: "bold",
                        children: "$10 off Hotel Express Deals*!"
                    })
                ]
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                fontSize: 1,
                mb: 2,
                mt: 1,
                children: "(limited time offer)"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Text, {
                fontSize: 0,
                color: "text.light",
                my: 3,
                fontWeight: "normal",
                children: "*Minimum spend $100"
            }),
            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Box, {
                children: [
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsxs)(external_pcln_design_system_namespaceObject.Button, {
                        variation: "fill",
                        width: 1,
                        mb: 2,
                        onClick: handleOpen,
                        children: [
                            "Let's Do It ",
                            /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_icons_namespaceObject.ExternalLink, {
                                ml: 2
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, jsx_runtime_namespaceObject.jsx)(external_pcln_design_system_namespaceObject.Button, {
                        variation: "subtle",
                        width: 1,
                        onClick: handleClose,
                        children: "No Thanks"
                    })
                ]
            })
        ]
    });
};
const Survey_Survey = Survey;
exports.RequestFromType = __webpack_exports__.RequestFromType;
exports["default"] = __webpack_exports__["default"];
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "RequestFromType",
    "default"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
